module.exports = __webpack_public_path__ + "static/img/banner4.d9ff7597.png";